/**
 * The list with one entry moved, leaving every other entry in its relative order.
 *
 * Written for the scene arc — GEN-45 — and moved here when the path member list became
 * its second caller. An index outside the list returns the list unchanged rather than
 * throwing: both callers read their indices off a drop event, and a drop that lands
 * nowhere is a gesture the user abandoned, not a fault.
 */
export function moved<T>(list: readonly T[], from: number, to: number): T[] {
  if (!inRange(list, from) || !inRange(list, to)) return [...list];

  const next = [...list];
  const [lifted] = next.splice(from, 1);

  if (lifted === undefined) return [...list];

  next.splice(to, 0, lifted);

  return next;
}

const inRange = (list: readonly unknown[], index: number): boolean =>
  Number.isInteger(index) && index >= 0 && index < list.length;
